import axios, { AxiosResponse } from 'axios';

import apiPaths from 'enums/apiPaths';

interface ILogin {
    token: string;
    pxklic?: boolean;
}

// Post metoda pro volani loginu, ktera nam vraci token jako string
const loginApi = async (username: string, password: string, lang: string, pxklic?: boolean) => {
    const resp: AxiosResponse<ILogin> = await axios({
        method: 'POST',
        url: apiPaths.LOGIN,
        data: {
            username,
            password,
            lang,
            ...(pxklic && {
                pxklic: true
            })
        }
    });
    return resp.data;
};

export default loginApi;
